import { createContext, useContext } from 'react';

export interface ArcheActionValue {
  // Trigger an action by ID
  triggerAction: (actionId: string, payload: Record<string, unknown>) => void;

  // Execute a sequence of action IDs with optional payload
  executeActionSequence: (actionIds: string[], payload?: Record<string, unknown>) => void;

  // Submit form data
  submitForm: (formData: Record<string, unknown>) => void;

  // Update input value
  updateInput: (key: string, value: unknown) => void;

  // Action execution state
  isExecuting: boolean;
  lastError: string | null;

  // AI streaming state
  isAIStreaming: boolean;
  aiStreamingText: Record<string, string>;
  aiThinkingText: Record<string, string>;

  // Stop an in-progress AI stream
  stopAIStreaming: () => void;
}

export const ArcheActionContext = createContext<ArcheActionValue | null>(null);

export function useArcheAction(): ArcheActionValue {
  const context = useContext(ArcheActionContext);
  if (!context) {
    // Return a default no-op implementation if not in provider
    return {
      triggerAction: (actionId, payload) => {
        console.warn(`Action ${actionId} triggered outside ArcheProvider`, payload);
      },
      executeActionSequence: (actionIds, payload) => {
        console.warn('Action sequence triggered outside ArcheProvider', actionIds, payload);
      },
      submitForm: (formData) => {
        console.warn('Form submission outside ArcheProvider', formData);
      },
      updateInput: (key, value) => {
        console.warn(`Input update outside ArcheProvider: ${key}`, value);
      },
      isExecuting: false,
      lastError: null,
      isAIStreaming: false,
      aiStreamingText: {},
      aiThinkingText: {},
      stopAIStreaming: () => {
        console.warn('stopAIStreaming called outside ArcheProvider');
      },
    };
  }
  return context;
}

export default useArcheAction;
